import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-avisoprivacidad',
  templateUrl: './avisoprivacidad.component.html',
  styleUrls: ['./avisoprivacidad.component.css']
})
export class AvisoprivacidadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
